import {
  FETCH_STOCK_RETURNS_REQUEST,
  FETCH_STOCK_RETURNS_SUCCESS,
  FETCH_STOCK_RETURNS_FAILURE,
  CREATE_STOCK_RETURN_REQUEST,
  CREATE_STOCK_RETURN_SUCCESS,
  CREATE_STOCK_RETURN_FAILURE,
  UPDATE_STOCK_RETURN_REQUEST,
  UPDATE_STOCK_RETURN_SUCCESS,
  UPDATE_STOCK_RETURN_FAILURE,
  PROCESS_STOCK_RETURN_REQUEST,
  PROCESS_STOCK_RETURN_SUCCESS,
  PROCESS_STOCK_RETURN_FAILURE,
  DELETE_STOCK_RETURN_REQUEST,
  DELETE_STOCK_RETURN_SUCCESS,
  DELETE_STOCK_RETURN_FAILURE
} from '../../types/stockReturn/stockReturnTypes';
import {
  fetchStockReturns,
  createStockReturn,
  updateStockReturn as updateStockReturnApi,
  processStockReturn,
  deleteStockReturn
} from '../../../api/stockReturn/stockReturnApi';

export const getStockReturns = () => async (dispatch) => {
  dispatch({ type: FETCH_STOCK_RETURNS_REQUEST });
  try {
    const { data } = await fetchStockReturns();
    dispatch({ type: FETCH_STOCK_RETURNS_SUCCESS, payload: data });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch stock returns';
    dispatch({ type: FETCH_STOCK_RETURNS_FAILURE, payload: errorMessage });
  }
};

export const addStockReturn = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_STOCK_RETURN_REQUEST });
  try {
    const { data } = await createStockReturn(payload);
    dispatch({ type: CREATE_STOCK_RETURN_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create stock return';
    dispatch({ type: CREATE_STOCK_RETURN_FAILURE, payload: errorMessage });
    throw error;
  }
};

export const updateStockReturn = (id, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_STOCK_RETURN_REQUEST });
  try {
    const { data } = await updateStockReturnApi(id, payload);
    dispatch({ type: UPDATE_STOCK_RETURN_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update stock return';
    dispatch({ type: UPDATE_STOCK_RETURN_FAILURE, payload: errorMessage });
    throw error;
  }
};

export const processReturn = (id, processed_by) => async (dispatch) => {
  dispatch({ type: PROCESS_STOCK_RETURN_REQUEST });
  try {
    const { data } = await processStockReturn(id, processed_by);
    dispatch({ type: PROCESS_STOCK_RETURN_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to process stock return';
    dispatch({ type: PROCESS_STOCK_RETURN_FAILURE, payload: errorMessage });
    throw error;
  }
};

export const removeStockReturn = (id) => async (dispatch) => {
  dispatch({ type: DELETE_STOCK_RETURN_REQUEST });
  try {
    await deleteStockReturn(id);
    dispatch({ type: DELETE_STOCK_RETURN_SUCCESS, payload: id });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete stock return';
    dispatch({ type: DELETE_STOCK_RETURN_FAILURE, payload: errorMessage });
    throw error;
  }
}; 